import { IOrderTimeline } from 'models/orders'

// Ответ смены статуса — заказ без развёрнутых продавца и покупателя, поэтому целиком
// в строку таблицы его не кладём: берём отметки времени, от которых считаются сроки
export const pickOrderTimeline = ({
  status_history,
  order_confirmation_time,
  delivery_preparation_time,
  delivery_completion_time,
  paid_at
}: IOrderTimeline): IOrderTimeline => ({
  status_history,
  order_confirmation_time,
  delivery_preparation_time,
  delivery_completion_time,
  paid_at
})
